import Layout from "../components/layout/Layout";
import InitializeSetup from "../components/page/InitializeSetup";


const InitializeSetupPage = () => {

    return (
        <Layout>
            <InitializeSetup />
        </Layout>
    )
}

export default InitializeSetupPage